import { styled } from 'styled-components';

import { colors } from '#/theme/theme';

export const FooterContainer = styled.div<{
  $initialized: boolean;
  $loading: boolean;
}>`
  display: flex;
  flex-direction: column;

  ${(props) =>
    !props.$initialized || props.$loading
      ? `
      margin: 40px 0 20px;`
      : undefined}
`;

export const FooterLink = styled.a`
  color: ${colors.lightContentGrey};
  text-decoration: underline;
`;
